import {Component, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    DxTextBoxModule, DxValidatorModule, DxSelectBoxComponent, DxTagBoxComponent,
} from 'devextreme-angular';
import {CustomStore} from "devextreme-aspnet-data-nojquery";
import DataSource from 'devextreme/data/data_source';
import {DataSources, ICreateEmployeeCommand} from "@services";
import {UserRole} from "../../../../shared/constants";

@Component({
    selector: 'add-employee-form',
    templateUrl: './add-employee-form.component.html',
    providers: [DataSources],
    imports: [
        DxTextBoxModule,
        DxValidatorModule,
        CommonModule,
        DxSelectBoxComponent,
        DxTagBoxComponent,
    ]
})

export class AddEmployeeFormComponent implements OnInit {
    @Input() employeeRolesOnly: boolean = false;
    @Input() showShiftField: boolean = true;
    @Input() showCarrierFields: boolean = true;
    @Input() showSupplierFields: boolean = true;
    @Input() showVendorFields: boolean = true;
    @Input() showCustomerFields: boolean = true;
    @Input() showSiteFields: boolean = true;
    @Input() showAgencyFields: boolean = true;

    private dataSources = inject(DataSources);

    data: ICreateEmployeeCommand = {} as ICreateEmployeeCommand;
    shiftDataSource = this.dataSources.shiftOptions();
    rolesDataSource: CustomStore | DataSource;
    supplierDataSource = this.dataSources.supplierOptions();
    carrierDataSource = this.dataSources.carrierOptions();
    vendorDataSource = this.dataSources.vendorOptions();
    customerDataSource = this.dataSources.customerOptions();
    siteDataSource = this.dataSources.siteOptions();
    agencyDataSource = this.dataSources.agencyOptions();

    ngOnInit(): void {
        this.rolesDataSource = this.employeeRolesOnly
            ? this.dataSources.employeeRoleOptions()
            : this.dataSources.roleOptions();
    }

    get isSupplierSelected(): boolean {
        return this.data.roles?.includes(UserRole.Supplier) ?? false;
    }

    get isCarrierSelected(): boolean {
        return this.data.roles?.includes(UserRole.Carrier) ?? false;
    }

    get isVendorSelected(): boolean {
        return this.data.roles?.includes(UserRole.Vendor) ?? false;
    }

    get isCustomerSelected(): boolean {
        return this.data.roles?.includes(UserRole.Customer) ?? false;
    }

    get isFinanceSelected(): boolean {
        return this.data.roles?.includes(UserRole.Finance) ?? false;
    }

    get isAgencySelected(): boolean {
        return this.data.roles?.includes(UserRole.Agency) ?? false;
    }

    getData = () => ({...this.data} as ICreateEmployeeCommand)
}
